import { useSearchCardsContext } from '@sorare/core/src/contexts/searchCards';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { useRemoveMarketFilterChipEvent } from 'hooks/events/useRemoveMarketFilterChipEvent';
import { useFormatFilterWidgetValue } from 'hooks/search/useFormatFilterWidgetValue';

import { FilterChip } from '../FilterChip';

export const VirtualToggleActiveFilters = ({
  setVirtualToggleFilters,
}: {
  setVirtualToggleFilters: (virtualToggle: {
    [name: string]: string | string[] | boolean | undefined;
  }) => void;
}) => {
  const {
    favoriteFilter,
    notInLineUpFilter,
    competitionEligibilityFilter,
    customDecksFilter,
    gameweekFilter,
    dailyFilter,
    probablePitchersFilter,
    promotionalEvent,
    watchlistFilter,
  } = useSearchCardsContext();
  const trackRemoveMarketFilterChip = useRemoveMarketFilterChipEvent();
  const { formatFilterWidgetValue } = useFormatFilterWidgetValue();
  const { sport } = useSportContext();

  const virtualToggleFilters = [
    {
      filter: VIRTUAL_TOGGLE_FILTERS.gameweekFilter,
      condition: gameweekFilter,
      value: gameweekFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.dailyFilter,
      condition: dailyFilter,
      value: dailyFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.probablePitchersFilter,
      condition: probablePitchersFilter,
      value: probablePitchersFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.favoriteFilter,
      condition: false,
      value: favoriteFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.notInLineupFilter,
      condition: notInLineUpFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.competitionEligibilityFilter,
      condition: competitionEligibilityFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.customDecksFilter,
      condition: customDecksFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.promotionalEventFilter,
      condition: promotionalEvent,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.watchlistFilter,
      condition: watchlistFilter,
    },
  ];

  return (
    <>
      {virtualToggleFilters
        .filter(({ condition }) => !!condition)
        .map(virtualToggle => {
          const labels = formatFilterWidgetValue(virtualToggle.filter);
          return labels.map(label => (
            <FilterChip
              key={label}
              label={label}
              onClose={() => {
                setVirtualToggleFilters({
                  [virtualToggle.filter.name]:
                    virtualToggle.filter.defaultValue,
                });
                if (sport) {
                  trackRemoveMarketFilterChip(
                    virtualToggle.filter.trackingName,
                    virtualToggle.value?.toString() || label,
                    sport
                  );
                }
              }}
            />
          ));
        })}
    </>
  );
};
